import { Fragment, FunctionalComponent, h } from "preact";
import { useAppSelector } from "../../redux/hooks";
import { Tag } from "../../models/interfaces";
// import { SearchItemType, SelectedDocumentType } from "../../models/enums";
import desktop from "../search/desktop.css";
// import SearchResultsDesktop from "../search/searchResultsDesktop";
import { useEffect, useRef, useState } from "preact/hooks";
import { get_AI_URI_BASE, getIsEdge } from "../../configs/env";
import { getSassToken } from "../../utils";
import PoweredByKorra from "../../components/poweredByKorra";
import BackgroundBanner from "../../components/BackgroundBanner";
import DocumentViewer from "../../components/DocumentViewer";
import DocumentsTable from "../../components/home/KeywordDocuments";
import CategoryFilters from "../../components/saerchResults/CategoryFilters";
import Spinner from "../search/spinner";

interface Props {
  workspaceId: string;
  // kappId?: string;
  portalId?: string;
  workspaceAlias?: string;
  portalAlias?: string;
  q: string;
  selectedItems: any;
  // withGpt: boolean;
  // textRequested: boolean;
  // textToShow: string;
  // showExtendedFilters: boolean;
  // setShowExtendedFilters: (showExtendedFilters: boolean) => void;
  // isInitalState: () => boolean;
  // countSelectedKapps: () => number;
  selectAllTopics: () => void;
  isAllTopics: () => boolean;
  filtersToggleKappSelection: (kapp: any) => void;
  filterTagsForUI: (tag: Tag) => boolean;
  tagClicked: (tag: Tag) => void;
  removeTag: (tag: any) => void;
  clearAllFilters: () => void;
  isMobileOnly: number | boolean;
  loading: boolean;
  // filtersLoaded: boolean;
  // noResults: boolean;
  // noSources: boolean;
  // NOANSWER: boolean;
  errorDesc: string;
  // selectedDocumentType: SelectedDocumentType;
  // fixLines: (text: string, style: string, type: string) => h.JSX.Element;
  // showAll: boolean;
  // setShowAll: (value: boolean) => void;
  // setSelectedDocumentTypeFilter: (value: SelectedDocumentType) => void;
  // filterSearchResults: (searchResult: any) => boolean;
  // getSearchItemType: (searchResult: any) => SearchItemType;
  // getChapterName: (searchResult: any) => any;
  queryLimitOn: boolean;
  isZeroIndex: boolean;
  handleCheckboxChange: any;
  selectedCategory: any;
  OnApplyFilters: () => void;
  clearCategoryFilters: () => void;
  handleNestedTagChange: (value: any) => void;
  setUpdateNestedTags: (value: any) => void;
  autoOpenDoc?: any;
  hideHeader?: boolean;
  currentPage: number;
  setCurrentPage: (page: number) => void;
}

const KeywordView: FunctionalComponent<Props> = (props: Props) => {
  const {
    workspaceId,
    // kappId,
    portalId,
    workspaceAlias,
    portalAlias,
    q,
    selectedItems,
    // withGpt,
    // textRequested,
    // textToShow,
    // showExtendedFilters,
    // setShowExtendedFilters,
    // isInitalState,
    // countSelectedKapps,
    selectAllTopics,
    isAllTopics,
    filtersToggleKappSelection,
    filterTagsForUI,
    tagClicked,
    removeTag,
    clearAllFilters,
    isMobileOnly,
    loading,
    // filtersLoaded,
    // noResults,
    // noSources,
    // NOANSWER,
    errorDesc,
    // selectedDocumentType,
    // fixLines,
    // showAll,
    // setShowAll,
    // setSelectedDocumentTypeFilter,
    // filterSearchResults,
    // getSearchItemType,
    // getChapterName,
    queryLimitOn,
    isZeroIndex,
    handleCheckboxChange,
    selectedCategory,
    OnApplyFilters,
    clearCategoryFilters,
    handleNestedTagChange,
    setUpdateNestedTags,
    autoOpenDoc,
    hideHeader,
  } = props;

  const alias = useAppSelector((state) => state.alias);
  const globals = useAppSelector((state) => state.globals);
  const appearance = useAppSelector((state) => state.appearance);
  const search = useAppSelector((state) => state.search);
  const [isPaying, setIsPaying] = useState<boolean>(true);
  const playerWrapper = useRef<HTMLDivElement>(null);
  const isFullScreen = useRef(false);
  const isInnerFullScreen = useRef<HTMLDivElement>(null);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const isExpandScreen = useRef(false);
  const videoContainerRef = useRef<HTMLDivElement>(null);
  const [docDetail, setDocDetail] = useState({
    type: "",
    kapp: "",
    docGuid: "",
    guid: "",
    page: "",
  });
  const [sasToken, setSasToken] = useState<string | undefined>(undefined);
  const handleToggleEpandScreen = () => {
    if (window.innerWidth > 1000) {
      isExpandScreen.current = !isExpandScreen.current;
      if (isExpandScreen.current && playerWrapper.current) {
        playerWrapper.current.style.display = "none";
      } else if (!isExpandScreen.current && playerWrapper.current) {
        playerWrapper.current.style.display = "block";
      }
    }
  };
  const handleToggleFullScreen = () => {
    isFullScreen.current = !isFullScreen.current;

    if (isFullScreen.current) {
      if (isMobileOnly && videoContainerRef.current) {
        const container = videoContainerRef.current;
        container.style.transform = "rotate(90deg)";
        container.style.transformOrigin = "bottom left";
        container.style.position = "absolute";
        container.style.top = "-100vw";
        container.style.left = "0";
        container.style.height = "100vw";
        container.style.width = "100vh";
        container.style.backgroundColor = "#000";
        container.style.color = "#fff";
        container.style.overflow = "auto";
      }
      if (isDrawerOpen && playerWrapper.current && isInnerFullScreen.current) {
        playerWrapper.current.style.width = "0%";
        isInnerFullScreen.current.style.display = "none";
      }
    } else {
      if (isMobileOnly && videoContainerRef.current) {
        const container = videoContainerRef.current;
        container.style.transform = "rotate(0deg)";
        container.style.transformOrigin = "";
        container.style.position = "";
        container.style.top = "0";
        container.style.left = "0";
        container.style.height = "96%";
        container.style.width = "100%";
        container.style.backgroundColor = "#000";
        container.style.color = "#fff";
        container.style.overflow = "auto";
      }
      if (playerWrapper.current && isDrawerOpen && isInnerFullScreen.current) {
        playerWrapper.current.style.width = "100%";
        isInnerFullScreen.current.style.display = "block";
      }
    }
  };
  useEffect(() => {
    if (!isDrawerOpen && playerWrapper.current && isInnerFullScreen.current) {
      playerWrapper.current.style.width = "100%";
      isInnerFullScreen.current.style.display = "block";
    }
  }, [isDrawerOpen]);

  useEffect(() => {
    if (autoOpenDoc) {
      setDocDetail(autoOpenDoc);
      setDrawerOpen(true);
    }
  }, [autoOpenDoc]);
  useEffect(() => {
    (async () => {
      if (workspaceId || alias.workspaceId) {
        const res = await fetch(
          `${get_AI_URI_BASE()}/payments/status?company_id=${
            workspaceId || alias.workspaceId
          }`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${globals.jwtUserIdToken}`,
            },
            method: "GET",
            mode: "cors",
          }
        );
        const status = await res.json();
        status["data"]["plan"] === "free" ? setIsPaying(false) : null;
      }
    })();
  }, [alias.workspaceId]);
  useEffect(() => {
    document.title = appearance.experienceName;
  }, [appearance.experienceName, isDrawerOpen]);

  useEffect(() => {
    if (docDetail?.type === "pdf" && docDetail?.docGuid) {
      const fetchSasToken = async () => {
        try {
          const token = await getSassToken(
            workspaceId || alias.workspaceId,
            portalId || alias.portalId || "",
            globals.userId || null,
            globals.jwtUserIdToken || null,
            getIsEdge()
          );
          setSasToken(token);
        } catch (error) {
          console.error("Failed to fetch SAS token:", error);
          setSasToken(undefined);
        }
      };

      fetchSasToken();
      const interval = setInterval(fetchSasToken, 3 * 60 * 1000);

      return () => clearInterval(interval);
    } else {
      setSasToken(undefined);
    }
  }, [
    docDetail,
    workspaceId,
    alias.workspaceId,
    portalId,
    alias.portalId,
    globals.userId,
    globals.jwtUserIdToken,
  ]);

  return (
    <div className={desktop.topWrapper}>
      <DocumentViewer
        isDrawerOpen={isDrawerOpen}
        docDetail={docDetail}
        setDrawerOpen={setDrawerOpen}
        handleToggleFullScreen={handleToggleFullScreen}
        handleToggleEpandScreen={handleToggleEpandScreen}
        videoContainerRef={videoContainerRef}
        sasToken={sasToken}
      />
      <div
        style={{
          width: "100%",
          display:
            (window.innerWidth < 1000 || appearance.isIframe) && isDrawerOpen
              ? "none"
              : "block",
        }}
        ref={playerWrapper}
      >
        {isPaying ? null : <PoweredByKorra />}
        <Fragment>
          {!hideHeader && (
            <BackgroundBanner
              workspaceId={workspaceId}
              portalId={portalId}
              isPaying={isPaying}
              workspaceAlias={workspaceAlias}
              portalAlias={portalAlias}
              value={q}
              showBack={true}
              isDrawerOpen={isDrawerOpen}
              isInnerFullScreen={isInnerFullScreen}
            />
          )}
          {loading ? (
            <Spinner isMobileOnly={isMobileOnly} isDrawerOpen={isDrawerOpen} />
          ) : queryLimitOn || errorDesc ? (
            <div className={desktop.queryLimit}>
              <img
                className={desktop.KorraIcon}
                src="/assets/icons/korra-logo.svg"
                alt="logo icon"
              />
              <br />
              <br />
              <br />
              {isZeroIndex ? (
                <span>
                  Search is currently unavailable because there are no ready
                  files in the knowledge base.
                </span>
              ) : (
                <span>
                  The service is currently on hold as this account has reached
                  its monthly query limit.
                  <br /> Please contact your administrator{" "}
                </span>
              )}
            </div>
          ) : (
            <div
              style={{
                height: !isPaying ? "58dvh" : hideHeader ? "100vh" : "60dvh",
                overflowY: "auto",
                scrollbarWidth: "thin" /* For Firefox */,
                scrollbarColor: "#888 #f1f1f1",
              }}
            >
              <div>
                {appearance.filtersType !== "none" && !isDrawerOpen && (
                  <CategoryFilters
                    clearAllFilters={clearAllFilters}
                    filterTagsForUI={filterTagsForUI}
                    tagClicked={tagClicked}
                    removeTag={removeTag}
                    selectAllTopics={selectAllTopics}
                    isAllTopics={isAllTopics}
                    filtersToggleKappSelection={filtersToggleKappSelection}
                    handleCheckboxChange={handleCheckboxChange}
                    selectedCategory={selectedCategory}
                    OnApplyFilters={OnApplyFilters}
                    clearCategoryFilters={clearCategoryFilters}
                    selectedItems={selectedItems}
                    handleNestedTagChange={handleNestedTagChange}
                    setUpdateNestedTags={setUpdateNestedTags}
                  />
                )}
                <div
                  style={{
                    width: isDrawerOpen ? "100%" : "55%",
                    margin: "auto",
                    marginTop: "50px",
                  }}
                >
                  <DocumentsTable
                    documents={search.keywordsDocuments.source}
                    setDocDetail={setDocDetail}
                    setDrawerOpen={setDrawerOpen}
                    totalPages={search.keywordsDocuments.pages}
                    currentPage={props.currentPage}
                    onPageChange={props.setCurrentPage}
                  />
                </div>
              </div>
            </div>
          )}
        </Fragment>
      </div>
    </div>
  );
};

export default KeywordView;
